export function StatusBadge({ status }: { status?: string | null }) {
  const s = (status || "unknown").toLowerCase();
  const tone =
    ["verified", "released", "completed", "paid", "sent", "approved"].includes(s) ? "bg-emerald-50 text-emerald-700 ring-emerald-200" :
    ["escrow_held", "held", "queued", "pending_verification", "pending", "initiated", "needs_wallet"].includes(s) ? "bg-amber-50 text-amber-700 ring-amber-200" :
    ["offered", "in_progress", "onboarding", "assigned"].includes(s) ? "bg-blue-50 text-blue-700 ring-blue-200" :
    ["checkout_pending_release", "needs_admin"].includes(s) ? "bg-purple-50 text-purple-700 ring-purple-200" :
    ["rejected", "disputed", "failed", "expired", "suspended"].includes(s) ? "bg-red-50 text-red-700 ring-red-200" :
    "bg-slate-100 text-slate-700 ring-slate-200";
  return (
    <span className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold ring-1 ${tone}`} data-testid={`status-badge-${s}`}>
      {s.replace(/_/g, " ")}
    </span>
  );
}

export function TierBadge({ type }: { type?: string | null }) {
  if (!type) return <span className="text-xs text-brand-slate">—</span>;
  const employed = type === "employed";
  return (
    <span className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold ${employed ? "bg-brand-blue text-white" : "bg-brand-goldSoft text-amber-800"}`} data-testid={`tier-badge-${type}`}>
      {employed ? "Tier A · Employed" : "Tier B · Self-employed"}
    </span>
  );
}

export function EmptyState({ title, body, testId }: { title: string; body: string; testId: string }) {
  return (
    <div className="rounded-2xl border border-dashed border-brand-line bg-white/60 p-10 text-center" data-testid={testId}>
      <p className="font-heading text-lg font-semibold text-brand-navy">{title}</p>
      <p className="mx-auto mt-1 max-w-md text-sm text-brand-slate">{body}</p>
    </div>
  );
}
